import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';

const FFBInfoBanner = ({styles, onClick}) => {

  useEffect(() => {
    const thisElement = document.querySelector(`.${styles.FFBInfoBanner}`);
    const onClickAnywhereHandler = (event) => {
      if (!thisElement.contains(event.target)) {
        onClick(event); // clicked outside the container
      }
    };
    /*
     * Delay adding listener to avoid catching the click that opened the modal.
     * React 18 renders synchronously within the same event loop tick, so the
     * click event that triggers showInfo=true also bubbles to document.body
     * and immediately fires this handler, closing the modal.
     */
    const timeoutId = setTimeout(() => {
      document.body.addEventListener('click', onClickAnywhereHandler);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.body.removeEventListener('click', onClickAnywhereHandler);
    };
  });

  return (
    <div className={styles.FFBInfoBanner}>
      <h2>Advanced Search Operators</h2>
      <div className={styles.HeaderSeparator} />
      <div className={styles.OperatorContainer}>
        <div>
          <ul>
            <li>
              <span>AND</span>
              <span>Use logical operators between terms.<br />Please note they must be in Capital Letters</span>
            </li>
            <li>
              <span>OR</span>
              <span><br /><br /></span>
            </li>
            <li>
              <span>AND NOT</span>
              <span />
            </li>
            <li>
              <div className={styles.OperatorSeparator} />
            </li>
            <li>
              <span>@</span>
              <span>Use to search for mentions of someone</span>
            </li>
            <li>
              <div className={styles.OperatorSeparator} />
            </li>
            <li>
              <span>from:</span>
              <span>Use to search for all posts from a certain author (user name)
                <br />
                <span className={styles.OperatorExample}>For example: from:username1</span>
              </span>
            </li>
            <li>
              <div className={styles.OperatorSeparator} />
            </li>
            <li>
              <span>source:</span>
              <span>Use to filter the results of a search to only a specific source
                <br />
                <span className={styles.OperatorExample}>For example: keyword1 AND source:news</span>
              </span>
            </li>
          </ul>
        </div>
        <div>
          <ul>
            <li>
              <span>country:</span>
              <span>Use to filter the results of a search to only posts that originated from a specific country. You will need to specify the country code.
                <br />
                <span className={styles.OperatorExample}>For example: keyword1 AND country:US</span>
              </span>
            </li>
            <li>
              <div className={styles.OperatorSeparator} />
            </li>
            <li>
              <span>geo_distance:</span>
              <span>
                Use to search for all posts that a user tagged from a certain radius from a selected set of coordinates.
                You will need to specify the exact latitude and longitude coordinates and set the distance in kilometers.
                You will need to separate the parameters with OR
                <br />
                <span className={styles.OperatorExample}>For example: geo_distance: (38.8981287 OR -77.0451993 OR 40)</span>
              </span>
            </li>
            <li>
              <div className={styles.OperatorSeparator} />
            </li>
            <li>
              <span>geo_bounding_box:</span>
              <span>
                Use to search for all posts that a user tagged within a specified bounding box.
                You will need to specify the latitude and longitude coordinates for the North-western and South-eastern vertices.
                You will need to separate the parameters with OR
                <br />
                <span className={styles.OperatorExample}>For example: geo_bounding_box: (38.8981287 OR -77.0451993 OR 38.8923626 OR -77.0291456)</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

FFBInfoBanner.propTypes = {
  styles: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default themeable(FFBInfoBanner);
